import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React from 'react';
import RouterPaths from '../../constants/RouterPaths';

function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = useSelector((state) => state.auth.get('isAuthenticated'));

  if (!isAuthenticated) {
    return <Navigate to={RouterPaths.LOGIN} replace />;
  }

  return Component ? <Component {...rest} /> : <Outlet />;
}

export default ProtectedRoute;
